import type { ConstraintFilterCondition } from '@/types/api/constraints'

import { createLogger } from '@/lib/logger'

const LOGGER = createLogger('components/pages/model-builder/allow-map')

export enum AllowEnum {
  Allow = 'allow',
  DontAllow = 'dont_allow',
}

export const AllowMap = {
  Allow: {
    label: 'Allow',
    value: AllowEnum.Allow,
  },
  DontAllow: {
    label: "Don't allow",
    value: AllowEnum.DontAllow,
  },
}

export enum AllowBlockRequireEnum {
  Allow = 'allow',
  Block = 'block',
  Require = 'require',
}

export const AllowBlockRequireMap = {
  Allow: {
    label: 'Allow',
    value: AllowBlockRequireEnum.Allow,
  },
  Block: {
    label: 'Block',
    value: AllowBlockRequireEnum.Block,
  },
  Require: {
    label: 'Require',
    value: AllowBlockRequireEnum.Require,
  },
}

export const toIsAllowableFilterCondition = (
  value: [AllowEnum],
): ConstraintFilterCondition | undefined => {
  // If the value is allow, return undefined, because we don't want to filter at all.
  // If the value were true, this would imply that we only want values with an explicit true.
  // (e.g., Allow sinkable bonds should mean sinkable and nonsinkable bonds are both okay, but if
  // we used true rather than undefined, we would be telling the API to only include sinkable bonds)
  return value[0] === AllowEnum.Allow
    ? undefined
    : {
        not_equal_to: true,
      }
}

// Allow = no filter, Block = exclude, Require = only include
export const toAllowBlockRequireFilterCondition = (
  value: [AllowBlockRequireEnum],
): ConstraintFilterCondition | undefined => {
  switch (value[0]) {
    case AllowBlockRequireEnum.Allow:
      return undefined
    case AllowBlockRequireEnum.Block:
      return { not_equal_to: true }
    case AllowBlockRequireEnum.Require:
      return { equal_to: true }
    default: {
      const exhaustiveCheck: never = value[0]
      LOGGER.warn('Unhandled AllowBlockRequireEnum value', {
        value: exhaustiveCheck,
      })
      return undefined
    }
  }
}
